import { api } from './api';
import { entriesAddMany } from '../containers/contentSlice';
import { GridEntry } from '../types';

export const gridsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		gridCreate: builder.mutation<GridEntry, GridEntry>({
			query: (entry) => {
				const grid = entry as GridEntry;
				return {
					url: 'grids',
					method: 'POST',
					body: {
						id: grid.id,
						parentId: grid.parentId,
						repositoryId: grid.repositoryId ?? null,
						primaryPropertyId: grid.primaryPropertyId ?? null,
						secondaryPropertyId: grid.secondaryPropertyId ?? null,
						direction: grid.direction ?? null,
						xy: grid.xy,
					},
				};
			},
			async onQueryStarted(entry, { dispatch }) {
				dispatch(entriesAddMany([entry]));
			},
		}),
	}),
});

export const { useGridCreateMutation } = gridsApi;
